import React from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import AlertProps from "./alert-component.props";
import "./alert-component.scss";

const AlertComponent: React.FC<AlertProps> = ({
  message,
  type,
  open,
  onClose,
  autoHideDuration = 3000,
}) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      className="alert-component"
      sx={{
        width: "auto",
        "& .MuiAlert-root": {
          width: "fit-content",
          display: "inline-flex",
          maxWidth: "calc(100vw - 32px)", // prevents overflow on small screens
        },
      }}
    >
      <Alert
        onClose={onClose}
        severity={type}
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          "& .MuiAlert-message": {
            padding: "8px 0",
          },
          "& .MuiAlert-icon": {
            display: "flex",
            alignItems: "center",
            padding: 0,
          },
          "& .MuiAlert-action": {
            display: "flex",
            alignItems: "center",
            padding: 0,
          },
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default AlertComponent;
